import { Team, User } from '../../../../../types/tournament';
import { IMatch } from '../PlayTag/PlayTag';
import { getDisplayName } from '../../../../../utils/userDisplayName';

type PrintableUser = User & {
    name?: string;
};

export const getPlayerName = (user: PrintableUser) => getDisplayName(user) || user.name || '';

function asUser(u: User | number | undefined | null): User | null {
    if (u != null && typeof u === 'object') return u;
    return null;
}

function usersFromTeam(team: Team | null | undefined): User[] {
    if (!team?.users?.length) return [];
    return team.users.map(asUser).filter((x): x is User => x !== null);
}

/** Prefer explicit match players; fall back to paired team.users (box league / API gaps). */
export function getSideDisplayNames(match: IMatch, side: 'home' | 'away'): { player1: string; player2: string } {
    const explicit1 = side === 'home' ? match.homePlayer1 : match.awayPlayer1;
    const explicit2 = side === 'home' ? match.homePlayer2 : match.awayPlayer2;
    const team = side === 'home' ? match.homeTeam : match.awayTeam;

    let u1 = asUser(explicit1);
    let u2 = asUser(explicit2);
    const pairUsers = usersFromTeam(team);

    if (!u1 && pairUsers[0]) u1 = pairUsers[0];
    if (!u2 && pairUsers[1]) u2 = pairUsers[1];

    if (u1 && !u2 && pairUsers.length >= 2) {
        u2 = pairUsers.find((m) => m.id !== u1!.id) ?? pairUsers[1];
    }

    const fallbackNames = team?.name
        ?.split('/')
        .map((name) => name.trim())
        .filter(Boolean) || [];

    return {
        player1: getPlayerName(u1 ?? ({} as User)) || fallbackNames[0] || '',
        player2: getPlayerName(u2 ?? ({} as User)) || fallbackNames[1] || '',
    };
}
